import './Repair.css'
import { useState } from 'react'
import { BUSINESS, REPAIRS } from '../data/site'

// "+91 98765 43210", "098765 43210" and "9876543210" all become "9876543210"
const cleanPhone = v => String(v).replace(/[^\d+]/g, '').replace(/^\+?91(?=\d{10}$)/, '').replace(/^0(?=\d{10}$)/, '')

const validate = f => {
  const e = {}
  const name = f.name.trim(), model = f.model.trim(), addr = f.address.trim(), note = f.message.trim()

  if (!name) e.name = 'Enter your name.'
  else if (!/^[\p{L}][\p{L}\s.'-]{1,59}$/u.test(name)) e.name = 'Use 2 to 60 letters. Numbers and symbols are not allowed.'

  if (!f.phone.trim()) e.phone = 'Enter your phone number.'
  else if (!/^[6-9]\d{9}$/.test(cleanPhone(f.phone))) e.phone = 'Enter a valid 10-digit mobile number starting with 6, 7, 8 or 9.'

  if (!model) e.model = 'Enter your phone model.'
  else if (!/^[\p{L}\p{N}][\p{L}\p{N}\s.+()/-]{1,39}$/u.test(model)) e.model = 'Enter a valid model, for example iPhone 14.'

  // optional, but if given it must be a real address
  if (addr && addr.length < 10) e.address = 'Enter the full pickup address (at least 10 characters), or leave it empty.'
  else if (addr.length > 250) e.address = 'Keep the address under 250 characters.'

  // optional message
  if (note.length > 500) e.message = 'Keep the message under 500 characters.'

  if (!f.issues.length) e.issues = 'Select at least one issue.'
  return e
}

export default function Repair() {
  const [form, setForm] = useState({ name: '', phone: '', model: '', address: '', message: '', issues: [] })
  const [touched, setTouched] = useState({})
  const [tried, setTried] = useState(false)
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))
  const blur = k => setTouched(t => ({ ...t, [k]: true }))
  const toggle = i => set('issues', form.issues.includes(i) ? form.issues.filter(x => x !== i) : [...form.issues, i])

  const errors = validate(form)
  const err = k => ((touched[k] || tried) ? errors[k] : '')

  const submit = e => {
    e.preventDefault()
    setTried(true)
    const first = Object.keys(errors)[0]
    if (first) {
      // move to the first problem so the customer sees what to fix
      const el = first === 'issues' ? document.querySelector('.repair .chip') : e.currentTarget.elements[first]
      el?.focus()
      return
    }
    const msg = `Repair pickup request\nName: ${form.name.trim()}\nPhone: +91 ${cleanPhone(form.phone)}\nDevice: ${form.model.trim()}\nIssues: ${form.issues.join(', ')}\nPickup address: ${form.address.trim() || 'Not given'}\nMessage: ${form.message.trim() || 'None'}`
    window.open(`https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(msg)}`, '_blank')
  }

  const bind = k => ({
    name: k,
    value: form[k],
    onBlur: () => blur(k),
    'aria-invalid': !!err(k),
    'aria-describedby': err(k) ? `rerr-${k}` : undefined,
  })
  const msg = k => err(k) && <span className="rform__err" id={`rerr-${k}`} role="alert">{err(k)}</span>

  return (
    <section className="repair" id="repair">
      <div className="repair__info">
        <h2 className="section__title">Phone broken? Don't come to us. We'll come to you.</h2>
        <p>Apple and Android repair with doorstep pickup and delivery. Choose what's wrong, then send the request on WhatsApp.</p>
        <div className="chips">
          {REPAIRS.map(r => (
            <button type="button" key={r} aria-pressed={form.issues.includes(r)}
              className={`chip ${form.issues.includes(r) ? 'chip--on' : ''}`} onClick={() => toggle(r)}>{r}</button>
          ))}
        </div>
        {tried && errors.issues && <p className="repair__err" role="alert">{errors.issues}</p>}
      </div>
      <form onSubmit={submit} className="rform" noValidate>
        <label>Name
          <input {...bind('name')} autoComplete="name" maxLength={60} onChange={e => set('name', e.target.value.replace(/[^\p{L}\s.'-]/gu, ''))} />
          {msg('name')}
        </label>
        <label>Phone
          <input {...bind('phone')} type="tel" inputMode="tel" autoComplete="tel" maxLength={16} placeholder="10-digit mobile number"
            onChange={e => set('phone', e.target.value.replace(/[^\d+\s-]/g, ''))} />
          {msg('phone')}
        </label>
        <label>Phone model
          <input {...bind('model')} maxLength={40} placeholder="e.g. iPhone 14, Galaxy S23" onChange={e => set('model', e.target.value)} />
          {msg('model')}
        </label>
        <label>Pickup address
          <textarea {...bind('address')} rows="2" maxLength={250} autoComplete="street-address" onChange={e => set('address', e.target.value)} />
          {msg('address')}
        </label>
        <label>Message (optional)
          <textarea {...bind('message')} rows="3" maxLength={500} placeholder="Tell us more about the problem, preferred pickup time, etc."
            onChange={e => set('message', e.target.value)} />
          {msg('message')}
        </label>
        <button className="btn btn--cobalt">Request pickup on WhatsApp</button>
      </form>
    </section>
  )
}